const tailwindConfig = require("../../../tailwind.config")
const screens = Object.values(tailwindConfig.theme.screens).reverse()
const screenNames = Object.keys(tailwindConfig.theme.screens).reverse()

export function isScreenOrBellow(screenName) {
    const index = screens.findIndex((size) => {
        return window.innerWidth > parseInt(size.replace("px", ""), 10)
    })
    const searchedScreenIndex = screenNames.indexOf(screenName)

    return index === -1 || searchedScreenIndex <= index
}

export function $(css, parent) {
    return (parent || document).querySelector(css)
}

export function $$(css, parent) {
    return Array.from((parent || document).querySelectorAll(css))
}

export function onReady(eventHandler) {
    if (document.readyState !== "loading") {
        eventHandler()
    } else {
        document.addEventListener("DOMContentLoaded", eventHandler)
    }
}

/**
 * @param {string|Element} element
 * @param {string} eventName
 * @param {Function} eventHandler
 * @param {Element|null} root
 */
export function on(element, eventName, eventHandler, root = null) {
    eventName.split(" ").forEach((event) => {
        if (typeof element === "string") {
            ;(root || document).addEventListener(
                event,
                function (e) {
                    // loop parent nodes from the target to the delegation node
                    for (
                        let target = e.target;
                        target && target !== this;
                        target = target.parentNode
                    ) {
                        if (target.matches(element)) {
                            eventHandler.call(target, e)
                            break
                        }
                    }
                },
                false
            )
        } else {
            element.addEventListener(event, eventHandler)
        }
    })
}

/**
 * @param {string|Element} element
 * @param {string} eventName
 * @param {Function|null} eventHandler
 * @param {Element|null} root
 */
export function off(element, eventName, eventHandler, root) {
    if (typeof element === "string") {
        ;(root || document).removeEventListener(eventName, eventHandler)
    } else {
        element.removeEventListener(eventName, eventHandler)
    }
}
